import React from 'react';
import { Box, Typography } from '@mui/material';
import { renderIconSvg } from '../components/charts/iconsSvg';

export default function ColorwayLegend({ colorway }) {
  const hasPatternColors = colorway && colorway.chromas && colorway.chromas.some((chroma) => chroma.isPattern);

  return (
    colorway && (
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 500, mb: 1 }}>
          KEY
        </Typography>
        {hasPatternColors && (
          <Typography variant="body2" sx={{ mb: 2 }}>
            Pattern Colors are in <b>BOLD</b>
          </Typography>
        )}
        <table>
          <tbody>
            {colorway.chromas &&
              colorway.chromas.map((chroma, index) => (
                <tr key={index}>
                  <td>
                    <div
                      style={{
                        width: 18,
                        height: 18,
                        margin: '0 auto',
                        backgroundColor: chroma.color,
                        border: '1px solid black',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <svg width="10" height="10" viewBox="0 0 10 10" style={{ display: 'block' }}>
                        {renderIconSvg(chroma.icon, chroma.color, chroma.isSolid)}
                      </svg>
                    </div>
                  </td>
                  <td
                    style={{
                      textAlign: 'center',
                      padding: '0 8px',
                      fontSize: 16,
                      fontWeight: chroma.isPattern ? 'bold' : 'normal'
                    }}
                  >
                    {chroma.id}
                  </td>
                  <td>
                    {chroma.name || chroma.code ? (
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: chroma.isPattern ? 'bold' : 'normal',
                          display: 'inline'
                        }}
                      >
                        {chroma.code} {chroma.name}
                      </Typography>
                    ) : (
                      <span
                        style={{
                          display: 'inline-block',
                          borderBottom: '1px solid black',
                          width: 200
                        }}
                      >
                        {' '}
                        &nbsp;{' '}
                      </span>
                    )}
                    &nbsp;
                    <i>{chroma.note && `(${chroma.note})`}</i>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    )
  );
}
